// Response from POST /v1/campaign/file/initiate (raw API response)
export interface IInitiateUploadResponseRaw {
    file_id: string;
    upload_id: string;
    presigned_urls: IPresignedPartRaw[];
    expires_at: string;
    chunk_size: number;
    total_parts: number;
}

// Raw presigned part from API
export interface IPresignedPartRaw {
    part_number: number;
    url: string;
    expires_at: string;
}

// Normalized response used internally
export interface IInitiateUploadResponse {
    file_id: string;
    upload_id: string;
    parts: IPresignedPart[];
    expires_at: string;
    chunk_size: number;
    total_parts: number;
}

export interface IPresignedPart {
    part_number: number;
    presigned_url: string;
    start_byte: number;
    end_byte: number;
}

// Request to POST /v1/campaign/file/initiate
export interface IInitiateUploadRequest {
    campaign_id: string;
    original_name: string;
    extension: string;
    mime_type: string;
    file_size: number;
}

// Request to POST /v1/campaign/file/{id}/part
export interface ICompletePartRequest {
    part_number: number;
    etag: string;
}

// Response from GET /v1/campaign/file/{id}/status
export interface IFileUploadStatus {
    file_id: string;
    status: 'pending' | 'uploading' | 'completed' | 'failed' | 'aborted';
    uploaded_parts: number[];
    total_parts: number;
    filename: string;
    file_size: number;
}

// Response from GET /v1/campaign/{id}/files
export interface ICampaignFile {
    id: string;
    campaign_id: string;
    original_name: string;
    extension: string;
    file_size: number;
    file_size_formatted: string;
    mime_type: string;
    status: 'uploading' | 'completed' | 'processing' | 'failed';
    status_display: string;
    progress: number;
    total_parts: number;
    completed_parts: number;
    created_at: string;
    upload_started_at: string | null;
    upload_completed_at: string | null;
}

// Internal upload tracking state
export interface IUploadProgress {
    fileId: string;
    file: File;
    filename: string;
    totalSize: number;
    uploadedBytes: number;
    progress: number; // 0-100
    status: 'pending' | 'uploading' | 'paused' | 'completed' | 'failed' | 'cancelled';
    error?: string;
    parts: IPartProgress[];
    startTime?: Date;
    estimatedTimeRemaining?: number;
}

export interface IPartProgress {
    partNumber: number;
    status: 'pending' | 'uploading' | 'completed' | 'failed';
    etag?: string;
    retries: number;
}

// Upload configuration
export const UPLOAD_CONFIG = {
    CHUNK_SIZE: 10 * 1024 * 1024, // 10MB
    MAX_FILE_SIZE: 5 * 1024 * 1024 * 1024, // 5GB
    ALLOWED_TYPES: [
        'text/csv',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ],
    ALLOWED_EXTENSIONS: ['.csv', '.xls', '.xlsx'],
    MAX_RETRIES: 3,
    RETRY_DELAY: 1000, // ms
    CONCURRENT_UPLOADS: 3 // Number of parts to upload simultaneously
};
